const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "use-edit",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.4 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.2,32.9c0,18.4-14.9,33.3-33.4,33.3s-33.4-14.9-33.4-33.3S45.4-.4,63.8-.4s33.4,14.9,33.4,33.3h0ZM90.2,32.9c0-7.3-2.6-13.5-7.7-18.6s-11.3-7.7-18.6-7.7-13.5,2.6-18.6,7.7c-5.2,5.1-7.7,11.3-7.7,18.6s2.6,13.5,7.7,18.6c5.1,5.2,11.3,7.7,18.6,7.7s13.5-2.6,18.6-7.7c5.1-5.2,7.7-11.3,7.7-18.6h0Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9,71.4c-7.3-1.9-15.5-2.8-24.5-2.8-33.6,0-55.2,12.9-64.9,38.5-2,5.2-1,10,2.9,14.3,3.7,4.1,8.6,6.1,14.6,6.1h41c1.6-.4,2.7-1.7,2.8-3.2,0-1.8-1.4-3.6-3.4-3.8H19c-3.6,0-6.4-1.2-8.6-3.5-2-2.3-2.6-4.8-1.5-7.5,8.4-22.5,27.6-33.7,57.5-33.7s16.5,1,23.4,2.9c1.4-.3,2.6-1.3,2.9-2.6.5-1.6-.3-3.5-1.9-4.5v-.2Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,82.8l11.5,10.6c.4.4,1.1.4,1.5,0h0l3.9-3.6c.4-.4.4-1,0-1.4h0l-11.5-10.6c-.4-.4-1.1-.4-1.5,0l-3.9,3.6c-.4.4-.4,1,0,1.4h0ZM91.7,87.7l-19.9,20.3c-.9,1-1.5,2.3-1.4,3.6v9.3c0,.5.6,1,1.1,1h11.1l21.4-21.8c.4-.4.4-1,0-1.4h0l-10.8-11c-.4-.4-1-.4-1.4,0h0ZM120.5,84.2c2.2,2.2,2.2,5.9,0,8.1l-33.7,33.6c-1.1,1.1-2.5,1.7-4.1,1.7h-12.1c-3.2,0-5.7-2.5-5.7-5.7v-12.2c0-1.5.6-3,1.7-4.1l33.7-33.5c2.2-2.2,5.9-2.2,8.1,0l12.2,12.2h0ZM98.5,120.5h20.8c1.6,0,2.9.7,2.9,3.3s-1.3,3.8-2.9,3.8h-20.8c-1.2,0-2.1-1.6-2.1-3.6s1-3.6,2.1-3.6h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEdit);
export default __webpack_public_path__ + "static/media/user-edit.2c1ca60fffa1b6c69b35f10e9901fff5.svg";
export { ForwardRef as ReactComponent };